import styled from "styled-components"

export default styled.span`
  opacity: 0.6;
`
